import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

export type ClaimsSequenceType = {
  [key: string]: string;
};

export const claimsSequenceStateSegment =
  stateSegmentWithReset<ClaimsSequenceType>({});
claimsSequenceStateSegment.debugLabel = 'claimsSequenceStateSegment';
